/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["h6.titulo[_ngcontent-%COMP%]{margin:0;background:#f7f7f7;padding:10px;border-bottom:0 solid #dedede;font-weight:700;width:100%}\n/*# sourceMappingURL=score-pf.component.css.map*/"];
export { styles as styles };
